<template>
  <div>
    <notify
      style="z-index: 999"
      :styles="alert.style !== undefined ? alert.style : 'top: 65px;'"
      :isWarning="alert.isWarning"
      @openMilestoneModal="openMileStoneModal"
      :isInfor="alert.isInfor"
      :notifIcon="alert.icon"
      :linkText="alert.linkText"
      :isActive.sync="alert.isActive"
      :message="alert.message"
    ></notify>
    <template v-if="authenticated">
      <navbar />
      <div :class="['container-fluid', isEditMode ? 'builder-bg' : 'pages-bg']">
        <div :class="['row', isEditMode ? 'builder-main' : null]">
          <sidebar v-if="!isEditMode"></sidebar>
          <router-view :class="editorContainerClass"></router-view>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <milestone-modal :message="alert.linkText" :tooltipDesc="alert.tooltipDesc" />
  </div>
</template>

<script>
  import Navbar from '@authoringPlatform/Navbar';
  import Sidebar from './components/pages/Dashboard/Sidebar';
  import MilestoneModal from './components/shared/MilestoneModal.vue';

  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'App',

    components: {
      Navbar,
      Sidebar,
      MilestoneModal,
    },

    created() {
      if (window.data && window.data.authenticated) {
        this.AUTHENTICATE_USER(window.data);
      }
      delete window.data;
    },

    watch: {
      authenticated: {
        immediate: true,
        handler(newStat, oldStat) {
          if (newStat === true && oldStat === false) {
            this.sendUserDataToPendo();
          }
        },
      },
    },

    computed: {
      ...mapState(['alert', 'isEditMode']),
      ...mapState('user', [
        'authenticated',
        'email',
        'firstName',
        'lastName',
        'isAdmin',
        'company',
        'companyType',
        'jobTitle',
      ]),

      editorContainerClass() {
        if (!this.isEditMode) return 'col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main';
        return null;
      },
    },

    methods: {
      ...mapMutations('user', ['AUTHENTICATE_USER']),
      openMileStoneModal(val) {
        $('#milestone-modal').modal('show');
      },

      sendUserDataToPendo() {
        const { email, firstName, lastName, isAdmin, company, companyType, jobTitle } = this;
        const { utmTags, referredFrom, useCase } = localStorage;

        let visitorData = {
          id: email,
          email: email,
          full_name: `${firstName} ${lastName}`,
          role: isAdmin ? 'Admin' : 'Author',
          Company: company,
          CompanyType: companyType,
          JobTitle: jobTitle,
          referredFrom,
          useCase,
        };

        if (utmTags) {
          visitorData = {
            ...visitorData,
            ...JSON.parse(utmTags),
          };
        }

        pendo.initialize({
          visitor: visitorData,
          account: {
            id: email,
            name: `${firstName} ${lastName}`,
          },
        });
      },
    },
  };
</script>

<style lang="scss">
  $icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';
  $navbar-height: 60px;
  $brand-success: #108137;
  $brand-danger: #df0816;
  $brand-primary: #0073ad;
  $font-size-base: 14px;

  @import '~bootstrap-sass/assets/stylesheets/_bootstrap.scss';
  @import '../../assets/sass/fa/fontawesome.scss';
  @import '../../assets/sass/fa/solid.scss';
  @import '../../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker';
  @import '../../assets/sass/tinymceCustomStyle.scss';
  .d-block {
    display: block;
  }

  .flex {
    display: flex !important;
  }

  .flex-column {
    flex-direction: column !important;
  }

  .flex-inline {
    display: inline-flex !important;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }
  .flex-row-wrap {
    flex-flow: row wrap !important;
  }
  .align-center {
    align-items: center !important;
  }
  .justify-start {
    justify-content: flex-start !important;
  }
  .justify-between {
    justify-content: space-between !important;
  }
  .justify-around {
    justify-content: space-around !important;
  }
  .justify-center {
    justify-content: center !important;
  }

  .btn-gray {
    color: black;
    background: #cfcfcf;
    border: darken(#cfcfcf, 1);
  }

  .btn-danger-ghost {
    background: white;
    color: $brand-danger;
    border: 1px solid $brand-danger;
  }

  .btn-primary-ghost {
    background: white;
    color: $brand-primary;
    border: 1px solid $brand-primary;
  }

  .full-height-builder {
    height: calc(100vh - 105px);
  }

  @media print {
    .full-height-builder {
      height: auto;
    }
    body {
      padding-top: 0 !important;
    }
  }

  body {
    font-family: 'Roboto', sans-serif;
    padding-top: 60px;
    font-size: 1.7rem;
    &.fullscreen {
      padding-top: 0;
    }
    &.home {
      padding-top: 0;
    }
  }

  // Placeholder styling begins
  .form-control::-webkit-input-placeholder {
    color: #646d78;
  }

  .form-control::-moz-placeholder {
    color: #646d78;
  }

  .form-control:-ms-input-placeholder {
    /** notice that ie has only a single colon) */
    color: #646d78;
  }

  .form-control::-webkit-input-placeholder {
    color: #646d78;
  }

  .form-control::placeholder {
    color: #646d78;
  }
  // Placeholder styling ends

  // Scrollbar styling begins
  ::-webkit-scrollbar {
    width: 8px !important;
    background-color: #f5f5f5 !important;
  }

  *::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    border-radius: 3px !important;
    background-color: #f5f5f5 !important;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 3px !important;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    background-color: #555 !important;
  }
  // Scrollbar styling ends

  .success-color {
    color: $brand-success;
  }

  .action-btn {
    border-radius: 5px;
    border: 1px dashed black;
    cursor: pointer;
    background: white;

    @extend .btn, .btn-block;
  }

  .bold-text {
    font-family: sans-serif;
    font-weight: bold;
  }

  /*
  * Main content
  */

  .main {
    padding: 20px;
    height: auto;

    min-height: calc(100vh - 60px);
  }

  .no-gutters {
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: 768px) {
    .main {
      padding-right: 40px;
      padding-left: 40px;
    }
  }

  .main .page-header {
    margin-top: 0;
  }

  .mat {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    // border: none !important;
  }

  .btn {
    @extend .mat;
  }

  .shadow-none {
    box-shadow: none !important;
  }

  .b-radius-none {
    border-radius: 0px;
  }

  $sides-list: 'top' 'left' 'right' 'bottom';

  @each $side in $sides-list {
    $i: 0;
    @while $i <= 60 {
      .m#{str-slice($side, 0, 1)}-#{$i} {
        margin-#{$side}: #{$i}px !important;
      }
      .p#{str-slice($side, 0, 1)}-#{$i} {
        padding-#{$side}: #{$i}px !important;
      }
      .m-#{$i} {
        margin: #{$i}px;
      }
      .p-#{$i} {
        padding: #{$i}px !important;
      }
      $i: $i + 5;
    }
  }

  .question-tag {
    font-size: 1.1rem;
    border-radius: 20px;
    display: inline;
    padding: 2px 5px;
    margin: 5px;
  }

  .feedback-tag {
    background-color: #cfcfcf !important;
  }

  .max-height {
    display: block;
    height: 100%;
  }

  .builder-bg {
    background: #e8e8e8;
  }

  .pages-bg {
    background: #f5f5f5;
  }

  .builder-main {
    height: calc(100vh - 60px);
  }

  @media print {
    .main {
      height: max-content !important;
    }
    .builder-main {
      height: max-content !important;
    }
  }

  #egg {
    position: absolute;
    display: inline-block;
    z-index: 1031;
    font-size: 4rem;
  }

  .info-box {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 3px;
    padding-bottom: 3px;
    display: inline-block;
  }

  small {
    font-size: 1.2rem;
  }
</style>
